import { NextButton, SecondaryButton } from '@/components/buttons/Buttons';
import Container, { CenterContent, Column, Row } from '@/components/container/Container';
import Spacing from '@/components/container/Spacing';
import FullScreenModal from '@/components/modals/FullScreenModal';
import { TextBodyMedium } from '@/components/text/Texts';
import Spinner from '@/components/utils/Spinner';
import { START } from '@/constants/button-labels';
import { useState } from 'react';
import styles from '../../onboarding.module.css';
import AccordionContentLayout from '../AccordionContentLayout';
import ChooseProgramWizard from '../ChooseProgramWizard';

export interface ChooseProgramWizardProps {
	onClose: () => void;
}
interface Props {
	isCompleted: boolean;
}

const ChooseProgramContent = (props: Props) => {
	const [showModal, setShowModal] = useState(false);
	const [isLoading, setIsLoading] = useState(true);

	setTimeout(() => {
		setIsLoading(false);
	}, 2000);

	const handler = () => {
		setShowModal(true);
	};

	return (
		<AccordionContentLayout>
			{<FullScreenModal
				visible={showModal}
				withCloseButton={true}
				setVisible={setShowModal}
				isCustomContent={true}
			>
				{isLoading ? (
					<CenterContent>
						<Spinner />
					</CenterContent>
				) : (
					<ChooseProgramWizard onClose={() => setShowModal(false)} />
				)}
			</FullScreenModal>}
			{/* TODO[Phase2]: the program is persisted currently using CreateOnboardingProgram. Things to implement:
			1. We also need to be able to update it.
			2. Rider per day and purposes collection (not sure if we need addition table or can store as comma-separate string) are not saved currently. */}
			{props.isCompleted ?
				<Column>
					<Row>
						<Column>
							<TextBodyMedium
								className={styles.onboardingContentBody}
								text="Travel programs allow you to cover business travel, daily commutes, or late-night rides. Customize your Travel program by setting rules such as trip locations and spending allowances."
							/>
							<Spacing height="h-[24px]" />
							<SecondaryButton
								width="w-[210px]"
								id="choose-program-next"
								label={'Change Program'}
								onClick={handler}
							/>
						</Column>
						<Spacing width="w-[124px] flex-shrink-0" />
						<Column>
							<Container className="w-[250px] align-top">
								<img
									className="rounded-[12px]"
									src="/images/image-placeholder.png"
									alt="decor"
									width={250}
									height={168}
								/>


							</Container>
						</Column>
					</Row>


				</Column> :
				<Column>
					<TextBodyMedium
						className={styles.onboardingContentBody}
						text="Begin by offering rides, meals, or delivery services. Select from a range of customizable programs tailored to suit your business requirements."
					/>
					<Spacing height="h-[24px]" />
					<NextButton
						width="w-[110px]"
						id="choose-program-next"
						label={START}
						onClick={handler}
					/>
				</Column>}
		</AccordionContentLayout>
	);
};

export default ChooseProgramContent;
